import { render, staticRenderFns } from "./Imballi.vue?vue&type=template&id=0bb5df7e&scoped=true&"
import script from "./Imballi.vue?vue&type=script&lang=js&"
export * from "./Imballi.vue?vue&type=script&lang=js&"
import style0 from "./Imballi.vue?vue&type=style&index=0&id=0bb5df7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb5df7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb5df7e')) {
      api.createRecord('0bb5df7e', component.options)
    } else {
      api.reload('0bb5df7e', component.options)
    }
    module.hot.accept("./Imballi.vue?vue&type=template&id=0bb5df7e&scoped=true&", function () {
      api.rerender('0bb5df7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/Imballi.vue"
export default component.exports